import { useMemo, useState } from "react";
import checkOpenTableContext, { CheckTableType } from "./checkOpenTableContext";

const CheckOpenTableProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const checkTableFilterString = localStorage.getItem("openCheckTableFilter");

  let InitialCheckTableFilterState = {
    identifier: "time",
    page: 0,
    sortingType: "desc",
  };

  if (checkTableFilterString !== null) {
    const { identifier, page, sortingType }: CheckTableType = JSON.parse(
      checkTableFilterString
    );

    InitialCheckTableFilterState = {
      identifier,
      page: Number(page),
      sortingType,
    };
  }

  const [checkOpenTableState, checkOpenTableSetState] =
    useState<CheckTableType>(InitialCheckTableFilterState);

  const stateValue = useMemo(
    () => [{ checkOpenTableState, checkOpenTableSetState }],
    [checkOpenTableState, checkOpenTableSetState]
  );

  return (
    <checkOpenTableContext.Provider value={stateValue}>
      {children}
    </checkOpenTableContext.Provider>
  );
};

export default CheckOpenTableProvider;
